export default __webpack_public_path__ + "static/media/img-touch-finger@3x.c86ad8fd.png";